'use client';
import { css } from 'styled-system/css'

export const quickBetSettingModalStyle = {
	header: css({
		base: {
			'--g-header-text': { base: 'var(--p500)', _dark: 'white' },
			'--m-header-text': { base: 'colors.brand.500', _dark: 'colors.whiteOpacity.100' },
			'--g-header-border-w': { base: '1px', _dark: '0px' },
			'--g-header-close': { base: '1px', _dark: '0px' },
			color: 'var(--g-header-text)',
			borderBottomColor: 'var(--lv1-8)',
			borderBottomWidth: 'var(--g-header-border-w)',
			borderBottomStyle: 'solid',
			h: '42px',

			'& .btn': {
				w: '24px',
				h: '24px'
			}
		},
		_mars: {
			color: 'var(--m-header-text)'
		}
	}),
	wrapper: css({
		base: {
			p: '12px 9px'
		}
	}),
	betInput: css({
		base: {
			'--g-bet-input-bg': { base: 'var(--s800)', _dark: '0px' },
			bgColor: 'var(--s800)',
		},
		_mars: {
			h: '30px'
		}
	}),
	stakeInput: css({
		base: {
			_ltr: {
				ml: 'auto',
			},
			_rtl: {
				mr: 'auto',
			}
		}
	}),
	input: css({
		base: {
			textAlign: 'end'
		}
	}),
	keypad: css({
		base: {
			px: 0,
			'& .keypad ': {
				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: 'var(--lv1-8)',
				mt: '12px'
			}
		}
	}),
	button: css({
		base: {},
		_mars: {
			backgroundColor: 'bettingModeModal.containerBg',
		},
	}),
	betButton: css({
		base: {
			h: '39px',
			w: '100%',
			maxWidth: '150px',
			m: '0 auto',
			borderRadius: '30px',
		},
		_mars: {
			'&[data-disabled=false]': {
				bgColor: 'brand.500',
				color: 'whiteOpacity.100',
			}
		},
	}),
	footer: css({
		base: {
			pb: '15px'
		}	
	}),
	info: css({
		base: {
			p: 0,
			mt: '12px',
			fontSize: '12px',
			_ltr: {
				textAlign: 'left'
			},
			_rtl: {
				textAlign: 'right'
			},
		}
	})
}